import { z } from "zod";
import { DocumentSchema } from "../../models/document.schema";

export const PrivateDocumentControllerResponseSchema = {
  documentDownloadUrl: z.string().nullable(),

  getNextLegislationNumber: z.string(),

  revertLegislationNumber: z.boolean(),

  listDocuments: DocumentSchema.array(),

  getDocument: DocumentSchema.nullable(),

  createDocument: DocumentSchema,

  updateDocument: DocumentSchema,

  deleteDocument: z.void(),
};
